import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from '../../../shared/enums/biocatchContext.enum';

import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductLoaderService } from './../../../shared/services/product-loader/product-loader.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustCA, callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { Console } from 'console';

@Component({
  selector: 'app-advisor-code',
  templateUrl: './advisor-code.component.html',
  styleUrls: ['./advisor-code.component.scss'],
})
export class AdvisorCodeComponent implements OnInit {
  formGroup: FormGroup;
  activeInput = false;
  vendorCodeNumber: any;

  config = {
    allowNegative: false,
    precision: 0,
  };
  /**
   * Información del documento
   * document information
   */
  documentInfo: DocumentModel;
  /**
   * Valida si el botón esta habilitado o no
   *
   * *Validates if the button is enabled or not*
   */
  listAdvisor: any;
  chanelid: any;

  /**
   * Valida si el input esta habilitado o no
   *
   * *Validates if the input is enabled or not*
   */
  advisorCodeInput = false;

  /**
   * Valida si el botón esta habilitado o no
   *
   * *Validates if the button is enabled or not*
   */
  isBtnDisabled = true;

  maskedAdvisorCode: string | null;
  /**
   * Variable tipo de producto
   *
   * *product type variable*
   *
   * @type {string}
   */
  product_type: string;
  /**
   * Variable contador de casos
   *
   * *get case count variable*
   *
   * @type {number}
   */
  callTimeOut = 0;
  /**
   * Variable numero de caso
   *
   * *case number variable*
   *
   * @type {string}
   */
  idCase: string;
  /**
   * Valida si el alert esta visible o no
   *
   * *Validates if the alert is visible or not*
   */
  showWarning = false;

  constructor(
    public copyService: CopyService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private productLoaderService: ProductLoaderService,
    private taggingServices: TaggingService,
    private formBuilder: FormBuilder,
    private bitacoraService: BitacoraService,
    private captureService: CaptureService,
    private requestService: RequestService,
    private parametersService: ParametersService,
    private bioCatchService: BioCatchService,
    private validationHelperService: ValidationHelperService,
    private biocatchService: BioCatchService,
    public channelCommunicatorService: ChannelCommunicatorService,
    private adjustEvent: AdjustEvent,
    private firmlyApprovedService: FirmlyApprovedService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendVirtualFranchisePageLoad();
    }
    this.chanelid = CHANNEL.PORTALO.CODE;

    this.navigationService.pageLoadTag(false, ['', '', 'pv583', '']);
    if (this.abreCuentasService.getproductSelected().product_type !== 'livingPlace') {
      this.restrictiveList();
    }
    const productSelected = this.abreCuentasService.getproductSelected();
    this.product_type = productSelected.product_type;
    const product = productSelected.product_code as ProductsBiocatchEnum;
    if (product === ProductsBiocatchEnum.VIV) {
      const isOriginal = !this.abreCuentasService.getIsPortal() && !this.abreCuentasService.getPostlogin();
      this.biocatchService.changeContext(StepBiocatchEnum.configuracion, product, isOriginal, true);
    }
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) { this.performIncomes(); }
    this.listAdvisor = [{
      label: this.copyService.copies.advisor_code_yes,
      elementId: 1,
      checked: this.abreCuentasService.getAdvisorCheck() === '1' ? true : false,
      value: true,
    },
    {
      label: this.copyService.copies.advisor_code_no,
      elementId: 2,
      checked: this.abreCuentasService.getAdvisorCheck() === '2' ? true : false,
      value: false,
    }];
    this.formGroup = new FormGroup({
      codeAdvisor: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(18),
        Validators.pattern(new RegExp(/^[Ññ\w-#/.,´´ ]+$/))]),
    });
    this.advisorCodeInput = this.abreCuentasService.getAdvisorCheck() === '1' ? true : false;
    this.activeInput = this.abreCuentasService.getAdvisorCheck() === '1' ? true : false;
    this.vendorCodeNumber = this.abreCuentasService.getAdvisorCode();
    this.formGroup.controls.codeAdvisor.setValue(this.vendorCodeNumber);
    this.isBtnDisabled = (this.abreCuentasService.getAdvisorCheck() === '1' ||
      this.abreCuentasService.getAdvisorCheck() === '2') ? false : true;
    this.changeWarningShow();
  }

  async performIncomes() {

    const bitacoraEvent = 'source_incomes';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.bitacoraService.saveDataInBitacora('Ini_loading_Incomes');
    await this.captureService.performIncomes().then((res: any) => {
      if (res !== '200') {
        this.bitacoraService.saveDataInBitacora('Out_loading_Incomes');
        this.navigationService.navigateToGeneralInformation('500');
        return;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  selectAdvisorCode(event: any) {
    this.advisorCodeInput = event.target.value === 'true' ? true : false;
    this.abreCuentasService.setAdvisorCheck(event.target.value === 'true' ? '1' : '2');
    if (!this.advisorCodeInput) {
      this.isBtnDisabled = false;
    } else {
      this.isBtnDisabled = true;
    }
    this.changeWarningShow(event);
  }

  reactiveInputChangeCode(event) {
    const InputControl = this.formGroup.controls['codeAdvisor'];
    const valueInput = InputControl.value;
    const currentInput = event.data;
    const validInputValidator = new RegExp(/^[0-9-]*$/g);
    if (!validInputValidator.test(currentInput) && currentInput) {
      InputControl.setValue(valueInput.replace(currentInput, ''));
      return;
    }
    this.abreCuentasService.setAdvisorCode(valueInput);
    this.vendorCodeNumber = valueInput;
    if ((valueInput.match(/-/g) || []).length >= 1) {
      const validateCode = new RegExp(/^([0-9]{2,}-[0-9]{1,})$/g);
      if (validateCode.test(valueInput)) {
        this.isBtnDisabled = false;
      } else {
        this.isBtnDisabled = true;
      }
    } else {
      const validateCode = new RegExp(/^[0-9]{4,}$/g);
      if (validateCode.test(valueInput)) {
        this.isBtnDisabled = false;
      } else {
        this.isBtnDisabled = true;
      }
    }
  }

  reactiveOnFocus() {
    this.activeInput = true;
  }
  async checkBioCatch() {
    await this.bioCatchService.update();
    this.bioCatchService.checkScore(false).then(response => {
      console.log('--------- Response Biocatch Score---------');
      console.log(response);
      if (response.data.response) {
        return;
      }
      this.navigationService.navigateToGeneralInformation('122');
      this.productLoaderService.hide();
      this.navigationService.pageLoadTag('Error carga vinculacion', ['', 'pv132', 'pv93']);
    }, () => {
      this.navigationService.navigateToGeneralInformation('500');
      this.productLoaderService.hide();
    }).catch(err => {
      console.log(err);
      this.navigationService.navigateToGeneralInformation('500');
    });
  }

  async next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    if (this.channelCommunicatorService.getChannelId() === this.chanelid) {
      this.advisorCodeInput = true;
    }
    const bitacoraEvent = `assisted_selling_${this.advisorCodeInput ? `yes_${this.vendorCodeNumber}` : 'no'}`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.abreCuentasService.setAdvisorCode(this.vendorCodeNumber);
    if (this.channelCommunicatorService.getChannelId() === this.chanelid) {
      this.abreCuentasService.setAdvisorCheck('1');
    }
    if (BUSINESS_CONST.PRODUCT_TYPE_LIVING === this.product_type) {
      this.productLoaderService.show(this.copyService.copies.show_load_pco,
        this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
      await this.captureService.performPco().then(async (res: any) => {
        this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
        if (res !== '200') {
          this.navigationService.navigateToGeneralInformation('107');
          return;
        }
        await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
        await this.captureService.getChannelComunicator(false, true).then((res2: any) => {
          (res2 === '107' || res2 === '121' || res2 === '130' || res2 === '129' || res2 === '124' || res2 === '127') ?
            this.navigationService.navigateToGeneralInformation(res2) :
            this.navigationService.nextStep(res2);
          if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && res2 === '121') {
            const event = {
              eventToken: 'huswfn',
              callbackParams: callbackAdjustContratarTC,
            };
            this.adjustEvent.adjustTrackEvent(event);
          }
          this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
        }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
      });
      this.bitacoraService.saveDataInBitacora('Out_loading_PCO');

      return;
    }
    if (this.abreCuentasService.haveLoan) {
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep('200');
      const postLogin = this.abreCuentasService.getPostlogin();
      const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
      const category = {
        module: 'body',
        type: 'button',
        position: 'bottom',
      };
      const CustomLabel = `Continuar`;
      // this.pageTagEvent('3', category, 'click', CustomLabel);
      if (postLogin && (product === 'TCR')) {
        this.pageTagEvent('3', category, 'click', CustomLabel, 'pv451');
      } else if (postLogin && (product === 'AHO')) {
        this.pageTagEvent('1', category, 'click', CustomLabel, 'pv571');
      } else if (!postLogin) {
        this.pageTagEvent('1', category, 'click', CustomLabel, 'pv583');
      }
    }
  }

  /**
   * @author Cristian Alexis Gallo Andrade
   * @creat_at 04/04/2022
   * Se encargará de obtener el código estado en sarlaft del cliente,
   * este metodo se traslada del componente form-employee
   * It will be in charge of obtaining the status code in the client's sarlaft,
   * this method is carried over from the component form-employee
   */

  async restrictiveList() {
    const restrictive_params = this.parametersService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
    const data_user = this.abreCuentasService.getDocumentInfo();
    const fullName = `${data_user.firstname} ${data_user.middlename} ${data_user.primary_lastname} ${data_user.second_lastname}`;
    const body = {
      data: {
        client_name: fullName,
        document: {
          number: data_user.document_number,
        },
        user_name: restrictive_params.user_name,
        employee_id: restrictive_params.employee_id,
        application: restrictive_params.application,
        priority: restrictive_params.priority,
        reference_type: restrictive_params.reference_type,
        transaction_type: restrictive_params.transaction_type,
      },
    };
    await this.requestService.getRestrictiveList(body).then(async (res: any) => {
      const data: any = {
        list_query_status: {
          status_code: res.data.status_code,
        },
        client: this.abreCuentasService.getProspectResponse().client,
      };
      this.abreCuentasService.setProspectResponse(data);
      if (res.data.status_code === '5') {
        this.navigationService.navigateToGeneralInformation('107');
        return;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }
  pageTagEvent(eventNumber: string, category: any, customAction: string, customLabel?: string, tag_name?: string) {
    const tagPageName = tag_name;
    let changes: Changes[] = [];
    if (`${tagPageName}E${eventNumber}transactionDetailsProductcategory`) {
      changes = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
        {
          path:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}clientElegibility`].path,
          value: this.abreCuentasService.getAdvisorCheck() === '1' ? 'Asesor | Si' : 'Asesor | No',
        },
      ];
    }

    const event: TagEvent = {
      category: {
        module: EVENT.customCategory.module[category.module],
        type: EVENT.customCategory.type[category.type],
        position: EVENT.customCategory.position[category.position],
      },
      action: EVENT.customAction[customAction],
      label: customLabel ? customLabel : EVENT[`${tagPageName}E${eventNumber}customLabel`],
    };
    const product = this.abreCuentasService.getproductSelected().product_code;
    product === 'TCR' ? this.taggingServices.pageTagEvent(event, changes) : this.taggingServices.pageTagEvent(event);
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendVirtualFranchisePageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv12pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv12pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv12pageFamily.path,
        value: PAGEVIEW_FA.pv12pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv12subFamily.path,
        value: PAGEVIEW_FA.pv12subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv12pageAction.path,
        value: PAGEVIEW_FA.pv12pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv12pageid.path,
        value: AdvisorCodeComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv12transactionName.path,
        value: `${PAGEVIEW_FA.pv12transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv12transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv12transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* ------------ Taggeo - Events ------------ */
  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv13E1setData.pv13E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv13E1setData.pv13E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv13E1setData.pv13E1transactionName.path,
        value: `${EVENT_FA_LD.pv13E1setData.pv13E1transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv13E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv13E2setData.pv13E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv13E2setData.pv13E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv13E2setData.pv13E2transactionName.path,
        value: `${EVENT_FA_LD.pv13E2setData.pv13E2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
      {
        path: EVENT_FA_LD.pv13E2setData.pv13E3clientElegibility.path,
        value: this.advisorCodeInput ? 'Si' : 'No',
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv13E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }
  sendTagging(value: any, position?: string, event?: string) {
    const page = '19';
    const extras = {
      object: 'clientElegibility',
      value: this.advisorCodeInput ? 'Si' : 'No',
      pageValue: 'AdvisorCode',
    };
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }

  changeWarningShow(event?: any) {
    if ((event ||
      this.channelCommunicatorService.getChannelId() == this.chanelid) &&
      this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS &&
      this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
      this.showWarning = true;
    } else {
      this.showWarning = false;
    }
  }

}
